import { render } from "./AdjustmentDataDialog.vue?vue&type=template&id=4651e652"
import script from "./AdjustmentDataDialog.vue?vue&type=script&lang=ts"
export * from "./AdjustmentDataDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script